import { PagosUserGuardService } from './../../../../servicios/guards/pagos-user.service';
import { PeriodicElement } from '../../../vergastos/vergastos.component';
import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, DoCheck } from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog} from '@angular/material';

import {SelectionModel} from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";

import { AuthService } from '../../../../servicios/auth.service';

import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';
import { environment } from "environments/environment";


export interface PeriodicElement {
  COD_DETALLE:string;
  FECHA_CARGA: string;
  FECHA_TICKET: string;
  DETALLE: string;
  IMPORTE: string;
  CATEGORIA: string;
  OBSERVACIONES: string;
  IMAGEN: string;
}
var ELEMENT_DATA: PeriodicElement[] = [];

@Component({
  selector: 'app-verdetalles-pagos',
  templateUrl: './verdetalles-pagos.component.html',
  styleUrls: ['./verdetalles-pagos.component.css']
})


export class VerdetallesPagosComponent implements OnInit {
  
  COD_DETALLE:string;
  FECHA_CARGA = new   Date;
  fecha_hoy: string;
  FECHA_TICKET: string;
  DETALLE: string;
  IMPORTE: string;
  CATEGORIA: string;
  OBSERVACIONES: string;
  IMAGEN: string;
  
  result;

  @ViewChild('TABLE') table: ElementRef;
  codgas;
  displayedColumns: string[] = ['select','COD_DETALLE', 'FECHA_CARGA', 'FECHA_TICKET', 'DETALLE', 'IMPORTE', 'CATEGORIA', 'OBSERVACIONES', 'IMAGEN'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  selection = new SelectionModel<PeriodicElement>(true, []);
  selectedDate;
  codi_detalle_edit: number;
  det_edit;
  imp_edit;
  fec_edit;
  tot_gasto;
  detallegasto_edit;
  fotito;
  loading;
  estadoElegido;

  constructor(
              private http: HttpClient,
              public dialog: MatDialog,
              private datePipe: DatePipe,
              //snackbar 2
              public snackBar: MatSnackBar
  ){
    this.loading=true;
   }

  transformDate(date) {
    this.datePipe.transform(this.FECHA_CARGA, 'yyyy-MM-dd'); //whatever format you need. 
  }

  selectRow(row, det, imp, fec, img) {
    this.codi_detalle_edit=row;
    this.det_edit = det;
    this.imp_edit = imp;
    this.fec_edit = fec;
    this.fotito = img;
    
    console.log(this.codi_detalle_edit);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Si el número de elementos seleccionados coincide con el número total de filas..
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

    //Selecciona todas las filas si no están todas seleccionadas; de lo contrario, borra la seleccion
    masterToggle() {
      this.isAllSelected() ?
          this.selection.clear() :
          this.dataSource.data.forEach(row => this.selection.select(row));
    }
    
    addEvent(input: string, $event) {
      this.selectedDate = moment($event.value).format('YY-MM-DD');
    }


    imprimirGastos(){
      localStorage.setItem('codgasto_edit', `${this.codgas}`);
      localStorage.setItem('imp_gasto',`${this.tot_gasto}`);
      console.log("enviando al local storage.. arrayGastoPrint");
      localStorage.setItem('arrayGastoPrint', JSON.stringify(this.dataSource.data));
      //console.log(JSON.parse(localStorage.getItem('arrayGastoPrint')));
      //this.router.navigate(['/print-gastos']); 
    }
  

  ngOnInit() {
    window.scroll(0,0);
    //controla el estadoElegido en la ventana anterior para ver si puede autorizar o no
    this.estadoElegido = localStorage.getItem('estadoElegido');
    console.log(this.estadoElegido);

    //carga titulo
    this.detallegasto_edit = localStorage.getItem('detallegasto_edit');
    this.tot_gasto = localStorage.getItem("imp_gasto");
    this.fecha_hoy = this.datePipe.transform(this.FECHA_CARGA,"yyyy-MM-dd");
    console.log(this.fecha_hoy);
    
    console.log(this.datePipe.transform(this.FECHA_CARGA,"yyyy-MM-dd"));
    this.codgas=localStorage.getItem('codgasto_edit');
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    setTimeout(() => {
      console.log("cargando grid..");
      this.cargaGrid();
    }, 1000);

  }

  cargaGrid(){
    this.http.get(`${environment.backendUrl}/api/vergastos/detalle?codgas=${this.codgas}&ima=SI`)
    .subscribe((data: any[]) => {
      this.dataSource.data = data;  
      this.loading=false; 
    });
    console.log("grid cargado..");
  }

  exportAsExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);//converts a DOM TABLE element to a worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `Gastos-${localStorage.getItem('apellidonombre')}_viaje.xlsx`);
  }

  enviarCodDetalle(){
    //al hacer click en editar en el modal, envio al local storage el codigo de gasto a editar
    localStorage.setItem('coddetalle_edit', `${this.codi_detalle_edit}`);  
    console.log(localStorage.getItem('coddetalle_edit'));
  }

  volver(){
    localStorage.removeItem('codgasto_edit');
    this.codgas = null;
    console.log("borro el codgasto to_edit");
  }

  autorizarGasto(){
  
    this.http.get(`${environment.backendUrl}/api/autorizargasto/autorizar?codgas=${this.codgas}&est=AUTORIZADO`)
    .subscribe((data: any) => {
      this.result = JSON.stringify(data["affectedRows"]);
      if (this.result==1){
        console.log(`GASTO COD: ${this.codgas} AUTORIZADO CORRECTAMENTE!`);
        //del navbar
        this.llenarNoti();
        this.snackBar.open(`GASTO [${this.codgas}] AUTORIZADO CORRECTAMENTE!`, 'Cerrar', {duration: 3000});

      }else{
        console.log(`el COD: ${this.codgas} no existe en la bd!`)
      }
    });
    
  }

  idsec=localStorage.getItem('seccional');
  noti;  
  
  llenarNoti(){
    //http://localhost:1337/api/notifi/noti?idse=21&est=PENDIENTE
    this.http.get(`${environment.backendUrl}/api/notifi/noti?idse=${this.idsec}&est=PENDIENTE`)
    .subscribe((data: any[]) => {
      this.noti = data[0]["TOT"]; 
      localStorage.setItem('notipend',this.noti);
      console.log(`noti= ${localStorage.getItem('notipend')}`); 
    });

  }

  download(){
    //return a promise that resolves with a File instance
    function urltoFile(url, filename, mimeType){
      mimeType = mimeType || (url.match(/^data:([^;]+);/)||'')[1];
      return (fetch(url)
          .then(function(res){return res.arrayBuffer();})
          .then(function(buf){return new File([buf], filename, {type:mimeType});})
      );
    }

    //Usage example:
    urltoFile(this.fotito,'ticketgasto','png')
    .then(function(file){
      console.log(file);
    })
  }
  
    //tocar imagen
    fullscreen(){
      document.getElementById("fotocopia").requestFullscreen();
    }
  
    //rotar imagen a lo mand
    cont=0;
    rotate(){
      this.cont = this.cont + 90;
      var img = document.getElementById("fotocopia");
      img.style.webkitTransform = `${this.cont}deg`;
      img.style.rotate = `${this.cont}deg`;
      img.style.transform = `rotate(${this.cont}deg)`;     
    }
    
    
  }






